import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import {
  AgentInfoWrapper,
  AgentInfo,
  AgentAvatar,
  AgentPersonalInfo,
  AgentImg,
  AgentName,
  AgentCompany,
  AgentMessage,
  MessageLink,
} from "./styles/agent-details-styles";

const AgentDetails = ({ name, company, avatar }) => (
  <AgentInfoWrapper>
    <AgentInfo>
      <AgentAvatar>
        <AgentImg src={avatar} alt={`${name}'s photo`} />
      </AgentAvatar>
      <AgentPersonalInfo>
        <AgentName>{name}</AgentName>
        <AgentCompany>{company}</AgentCompany>
      </AgentPersonalInfo>
      <AgentMessage>
        <MessageLink>
          <Link to="./messages">
            <FontAwesomeIcon icon={faComments} />
          </Link>
        </MessageLink>
      </AgentMessage>
    </AgentInfo>
  </AgentInfoWrapper>
);

AgentDetails.propTypes = {
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
};

export default AgentDetails;
